// extracted by mini-css-extract-plugin
export default {"root":"LoadTemplate_root__pEQsJ","wrapper":"LoadTemplate_wrapper__xAQxS","loader":"LoadTemplate_loader__e7i5V","deleteIcon":"LoadTemplate_deleteIcon__73NwJ"};